<template>
  <iRow vertical-align="middle">
    <AvatarImage :src="entity?.splashImageUrl ?? ''" size="75px" />
    <iButton @click="validateClick">
      Change Picture
    </iButton>
  </iRow>
</template>

<script>
// `~/stores/user-store` lives outside the editor directory tree.
// Canvas preview is a static mock; real upload runs on FanWeb.
import { UserSettingsPageElementMixin } from "%/dynamic-component-editor/standard-pages/user-settings-page/user-settings-page-element-mixin";
import AvatarImage from "%/dynamic-component-editor/components/AvatarImage.vue";

export default {
  name: "SplashImageUpload",
  components: {
    AvatarImage,
  },
  mixins: [UserSettingsPageElementMixin],
  elementPanelSettings: {
    displayName: "Splash Image Upload Field",
    displayIcon: "document",
    elementGroup: "userSettingsElements",
    elementType: "element",
  },
  methods: {
    validateClick(event) {
      if (this.editMode) {
        event.stopPropagation();
      }
    },
  },
};
</script>
